(function(){
  var SPECS = {
    V1:{s:'oval',w:2.36,h:3.15,f:false,small:true}, V2:{s:'oval',w:3.15,h:3.94,f:false},
    V3:{s:'oval',w:3.54,h:4.72,f:false}, V4:{s:'oval',w:4.33,h:5.91,f:false},
    V5:{s:'oval',w:5.11,h:7.09,f:false}, V6:{s:'oval',w:7.09,h:9.45,f:false},
    V7:{s:'oval',w:9.45,h:11.81,f:false},
    V1B:{s:'oval',w:2.8,h:3.6,f:true},  V2B:{s:'oval',w:3.7,h:4.5,f:true},
    V3B:{s:'oval',w:4.2,h:5.4,f:true},  V4B:{s:'oval',w:5.1,h:6.6,f:true},
    V5B:{s:'oval',w:5.9,h:7.8,f:true},
    V2C:{s:'oval',w:3.9,h:6.1,f:true,cover:true},
    R1:{s:'rect',w:2.36,h:3.15,f:false,small:true}, R2:{s:'rect',w:3.15,h:3.94,f:false},
    R3:{s:'rect',w:3.54,h:4.72,f:false}, R4:{s:'rect',w:4.33,h:5.91,f:false},
    R5:{s:'rect',w:5.11,h:7.09,f:false}, R6:{s:'rect',w:7.09,h:9.45,f:false},
    R7:{s:'rect',w:9.45,h:11.81,f:false},
    H3:{s:'heart',w:3.94,h:3.94,f:false}, H5:{s:'heart',w:6.10,h:6.10,f:false},
    C3:{s:'round',w:3.94,h:3.94,f:false}, C5:{s:'round',w:5.9,h:5.9,f:false},
    S1:{s:'square',w:3.94,h:3.94,f:false}
  };
  var SHAPE_LABEL = {oval:'Oval',rect:'Rectangle',heart:'Heart',round:'Round',square:'Square'};

  var CW=760, CH=620, PAD=54;
  /* On a real piece the fired image stops short of the edge, leaving a white
     porcelain rim. Photo and lettering clip to this inset, not the full shape. */
  /* 0.96, not 0.92. Measured off a real competitor proof at the widest point:
     the piece was 390px across and the porcelain rim 7px each side — an inset
     of 0.964 horizontally, 0.978 vertically (the rim is a fixed physical width,
     so it reads as a slightly smaller fraction on the long axis). At 0.92 ours
     left a border more than twice as thick, which shrinks the face and makes
     the piece look like a print in a mount rather than an image fired into the
     porcelain itself. */
  var INSET=0.955;
  var canvas, photo=null, texts=[], spec=null, sku='', horizontal=false, originalFile=null;
  var shapeBox={x:0,y:0,w:0,h:0};
  var graniteCache=null, graniteBgSet=false, placeholder=null, stageScale=1, lastText=null;

  function $(id){return document.getElementById(id);}

  /* ---------- procedural granite ---------- */
  function granite(w,h){
    var c=document.createElement('canvas'); c.width=w; c.height=h;
    var x=c.getContext('2d');
    /* polished dark granite — the usual ground for a ceramic portrait */
    x.fillStyle='#3c4043'; x.fillRect(0,0,w,h);
    var img=x.getImageData(0,0,w,h), d=img.data;
    for(var i=0;i<d.length;i+=4){
      var n=(Math.random()*2-1);
      d[i]  =Math.max(0,Math.min(255,d[i]  +n*26));
      d[i+1]=Math.max(0,Math.min(255,d[i+1]+n*26));
      d[i+2]=Math.max(0,Math.min(255,d[i+2]+n*27));
    }
    x.putImageData(img,0,0);
    for(var k=0;k<Math.round(w*h/620);k++){
      var px=Math.random()*w, py=Math.random()*h, r=Math.random()*3.6+0.6;
      var t=Math.random();
      x.fillStyle = t<0.34 ? 'rgba(232,235,238,'+(0.16+Math.random()*0.42)+')'
                  : t<0.60 ? 'rgba(16,17,19,'+(0.30+Math.random()*0.45)+')'
                  : t<0.82 ? 'rgba(146,152,158,'+(0.16+Math.random()*0.34)+')'
                           : 'rgba(120,98,64,'+(0.12+Math.random()*0.26)+')';
      x.beginPath(); x.ellipse(px,py,r,r*(0.55+Math.random()*0.7),Math.random()*3.14,0,6.28); x.fill();
    }
    /* specular sweep — the giveaway that the stone is polished */
    var sp=x.createLinearGradient(0,0,w*0.85,h);
    sp.addColorStop(0,'rgba(255,255,255,.16)'); sp.addColorStop(.28,'rgba(255,255,255,.05)');
    sp.addColorStop(.52,'rgba(255,255,255,0)');
    x.fillStyle=sp; x.fillRect(0,0,w,h);
    /* vignette so the piece sits forward */
    var vg=x.createRadialGradient(w/2,h/2,Math.min(w,h)*0.22,w/2,h/2,Math.max(w,h)*0.72);
    vg.addColorStop(0,'rgba(0,0,0,0)'); vg.addColorStop(1,'rgba(0,0,0,.42)');
    x.fillStyle=vg; x.fillRect(0,0,w,h);
    return c;
  }

  /* ---------- photographic product shots ----------

     Where there is a real photograph of the piece, use it instead of drawing
     one. Nothing here is hand-measured: on load the opening is found in the
     image itself and its outline traced, so adding a shot is one line in
     SHOTS. The self-check is that the found blob fills ~78.5% of its bounding
     box (pi/4) — that is what an ellipse does, and it is how we know we found
     the opening rather than a background or a reflection. */
  /* Shopify minifies theme JS, so when something goes wrong on the storefront
     the served file is not readable. This is the way back in. */
  var DBG=(window.GCZ_DEBUG=window.GCZ_DEBUG||{});
  var SHOT_BASE='https://cdn.shopify.com/s/files/1/0964/9946/6553/files/';
  /* m:'inner' — the porcelain sits inside bronze, find the bright region the
     bronze encloses. m:'piece' — a bare piece cut out on white, the whole
     piece is the opening. The two need opposite reasoning about what the
     background is, which is why it is stated per shot rather than guessed. */
  var SHOTS={
    'oval|frame|v':{f:'Oval_Pictures_for_Headstones_with_Bronze_Frames.png?v=1787796081', m:'inner'},
    'oval|cover|v':{f:'Oval_Pictures_for_Headstones_with_Bronze_Covers_vertical_portrait.png?v=1787796192', m:'inner'},
    'oval|cover|h':{f:'Oval_Pictures_for_Headstones_with_Bronze_Covers_horizontal_portrait.png?v=1787796309', m:'inner'},
    'oval|plain|v':{f:'Oval_Headstone_Pictures_Colored_background.png?v=1787839851', m:'inner', key:true},
    'heart|plain|v':{f:'Heart_Pictures_for_Headstones_Colored_Background.png?v=1787840052', m:'inner', key:true},
    /* Reshot on a saturated blue ground, which fixed this one properly. On the
       old concrete shot the piece shaded from 234 down to 213 while the ground
       ran 196-222 — they overlapped, no threshold could separate them, and the
       detected bottom fell ~90px short. Blue fails the neutral test outright,
       so the piece now detects at the default threshold: fill 0.987 (a rounded
       rectangle), dead centred, and stable whether the threshold is 188 or 210.
       `key` because that saturated ground is also what makes it safe to cut
       out — the piece goes on white like the other bare shapes rather than
       being the only one on a coloured background. */
    'rect|plain|v':{f:'Rectangle_Pictures_for_Headstones_Colored_Background.png?v=1787839706',
                    m:'inner', key:true},
    'square|plain|v':{f:'Square_Pictures_for_Headstones_Colored_Background.png?v=1787840203', m:'inner', key:true},
    'round|plain|v':{f:'Round_Pictures_for_Headstones_Colored_Background.png?v=1787840129', m:'inner', key:true}
  };
  var shotCache={};

  function shotKey(){
    if(!spec) return null;
    var kind = spec.cover ? 'cover' : (spec.f ? 'frame' : 'plain');
    var want = horizontal?'h':'v';
    var k = spec.s+'|'+kind+'|'+want;
    if(SHOTS[k]) return {k:k, rot:false};
    /* No landscape shot for this piece — turn the portrait one a quarter turn
       rather than fall back to it as-is. Showing a portrait piece to somebody
       who has just chosen landscape is worse than showing the drawing. The
       grounds are granite, concrete and plain white, none of which has an up. */
    var kv = spec.s+'|'+kind+'|v';
    if(SHOTS[kv]) return {k:kv, rot:(want==='h')};
    return null;
  }

  /* Find the opening: everything bright and near-neutral that is NOT reachable
     from the border. The border flood is what separates the piece from a white
     studio background — they are the same colour, so a plain threshold merges
     them into one blob and finds nothing. */
  function traceOpening(img, mode, thresh, shape){
    var W=img.naturalWidth, H=img.naturalHeight;
    var c=document.createElement('canvas'); c.width=W; c.height=H;
    var x=c.getContext('2d'); x.drawImage(img,0,0);
    var d;
    try{ d=x.getImageData(0,0,W,H).data; }
    catch(e){ return null; }               /* tainted — no CORS header */
    var N=W*H, bright=new Uint8Array(N), flood=new Uint8Array(N), i,r,g,b;

    if(mode==='piece'){
      /* A bare piece cut out on pure white: the whole piece IS the opening.
         The ground is a flat 255, the porcelain lands around 226 and drops to
         182 at the shaded underside, so "not white" separates them cleanly —
         checked against the pixels, the edge goes 168 -> 255 in one step with
         no shadow in between. Holes come free: a specular highlight that
         reads as pure white is not reachable from the border, so it stays
         part of the piece. */
      for(i=0;i<N;i++){
        r=d[i*4]; g=d[i*4+1]; b=d[i*4+2];
        bright[i]=1;
        if(r>=248&&g>=248&&b>=246) flood[i]=1;
      }
    } else {
      /* The opening is the bright neutral region that whatever surrounds it —
         bronze, or a darker ground — keeps separate from the outside. The
         border flood removes the background. The threshold matters and is per
         shot: the default 188 clears bronze and granite, but the rectangle
         sits on pale concrete that reads 210-222 against porcelain at 237-240,
         so that one needs 230 or the two merge into a single blob and the
         answer comes back as the whole image. */
      var t=(typeof thresh==='number') ? thresh : 188;
      for(i=0;i<N;i++){
        r=d[i*4]; g=d[i*4+1]; b=d[i*4+2];
        if(r>t&&g>t-2&&b>t-8&&Math.abs(r-g)<16&&Math.abs(g-b)<20&&Math.abs(r-b)<22){ bright[i]=1; flood[i]=1; }
      }
    }

    var vis=new Uint8Array(N), st=[], px, py, p;
    for(px=0;px<W;px++){ st.push(px); st.push((H-1)*W+px); }
    for(py=0;py<H;py++){ st.push(py*W); st.push(py*W+W-1); }
    while(st.length){
      p=st.pop(); if(vis[p]||!flood[p]) continue; vis[p]=1;
      px=p%W; py=(p-px)/W;
      if(px>0)st.push(p-1); if(px<W-1)st.push(p+1);
      if(py>0)st.push(p-W); if(py<H-1)st.push(p+W);
    }
    /* Label each blob with its OWN id, not a shared flag.

       This mattered more than it looks. With one shared mask every bright
       speck of grit on the concrete counted as part of the piece — the
       rectangle's corner radius was being measured off a speck sitting ten
       pixels above the piece and came out at 57px instead of 17. */
    var lab=new Int32Array(N), best=null, s, q, n, id=0, mnX, mxX, mnY, mxY, ax, ay, sumX, sumY;
    for(s=0;s<N;s++){
      if(!bright[s]||vis[s]||lab[s]) continue;
      id++;
      q=[s]; n=0; mnX=W; mxX=0; mnY=H; mxY=0; sumX=0; sumY=0;
      while(q.length){
        p=q.pop(); if(lab[p]||!bright[p]||vis[p]) continue; lab[p]=id;
        ax=p%W; ay=(p-ax)/W; n++; sumX+=ax; sumY+=ay;
        if(ax<mnX)mnX=ax; if(ax>mxX)mxX=ax; if(ay<mnY)mnY=ay; if(ay>mxY)mxY=ay;
        if(ax>0)q.push(p-1); if(ax<W-1)q.push(p+1);
        if(ay>0)q.push(p-W); if(ay<H-1)q.push(p+W);
      }
      if(!best||n>best.n) best={n:n,id:id,mnX:mnX,mxX:mxX,mnY:mnY,mxY:mxY,cx:sumX/n,cy:sumY/n};
    }
    if(!best || best.n < N*0.004) return null;
    var MID=best.id;

    /* Trace the outline by casting rays from the centroid. Every shape here —
       oval, rectangle, round, square, and even a heart with its notch — is
       star-shaped about its centroid, so one radius per angle describes it
       exactly, and it costs nothing next to a real contour trace. */
    var mask=lab, RAYS=360, rads=[], k, ang, rad, lastGood, tx, ty, ti;
    var maxR=Math.sqrt(W*W+H*H);
    for(k=0;k<RAYS;k++){
      ang=k/RAYS*6.283185307;
      var ca=Math.cos(ang), sa=Math.sin(ang);
      lastGood=0;
      for(rad=1;rad<maxR;rad+=1){
        tx=Math.round(best.cx+ca*rad); ty=Math.round(best.cy+sa*rad);
        if(tx<0||ty<0||tx>=W||ty>=H) break;
        ti=ty*W+tx;
        if(mask[ti]===MID) lastGood=rad;
        else if(rad-lastGood>2) break;   /* tolerate speckle, stop at a real edge */
      }
      rads.push(lastGood);
    }

    /* Smooth the radius before it becomes a path. The raw value wobbles by a
       pixel or two at every angle — the porcelain edge is antialiased, so the
       threshold lands in a slightly different place each time. Measured on a
       finished round piece the radius wandered between 255 and 267px with
       jumps of 10px between neighbouring angles, and that reads on screen as
       a scalloped, badly-cut edge. A circular moving average removes it; the
       window is narrow enough (±4 of 360, so ±4°) to leave a heart's notch. */
    var sm=[], WIN=4, q, acc;
    for(k=0;k<RAYS;k++){
      acc=0;
      for(q=-WIN;q<=WIN;q++) acc+=rads[(k+q+RAYS)%RAYS];
      sm.push(acc/(WIN*2+1));
    }

    var pts=[];
    for(k=0;k<RAYS;k++){
      ang=k/RAYS*6.283185307;
      pts.push([(best.cx+Math.cos(ang)*sm[k])/W, (best.cy+Math.sin(ang)*sm[k])/H]);
    }

    var bw=best.mxX-best.mnX+1, bh=best.mxY-best.mnY+1;
    var fill=best.n/(bw*bh);

    /* An oval or a round piece IS an ellipse, and an ellipse is described
       perfectly by its bounding box — so use one rather than a 360-sided
       approximation of it. No wobble is possible at all. The fill check
       guards it: pi/4 = 0.785, so anything outside 0.76-0.81 is not the
       ellipse we think it is and keeps the traced outline instead. */
    var exact=null, corner=0;
    if((shape==='oval'||shape==='round') && fill>0.76 && fill<0.81) exact='ellipse';

    /* A rectangle is the worst case for radial tracing: rays reach much further
       into the corners than to the edges, so the same pixel of noise swings the
       outline far more there, and the shaded right and bottom edges fall under
       the threshold and eat holes in it. A fitted rounded rectangle sidesteps
       all of it. The corner radius is read off the top edge, which is the
       brightest and best-detected part: at the very top the piece spans
       (width - 2r), so r follows from the run length. */
    if((shape==='rect'||shape==='square') && fill>0.88){
      /* At the very top row of a rounded rectangle the flat span is
         (width - 2r), so how far in the piece starts IS the corner radius.
         Measured over the first few rows and taking the smallest, so one
         ragged row cannot throw it. */
      var yy, xi, ins, bestIns=1e9;
      for(yy=best.mnY; yy<=Math.min(best.mnY+3,best.mxY); yy++){
        ins=null;
        for(xi=best.mnX; xi<=best.mxX; xi++){ if(mask[yy*W+xi]===MID){ ins=xi-best.mnX; break; } }
        if(ins!==null && ins<bestIns) bestIns=ins;
      }
      corner=(bestIns<1e9)?bestIns:0;
      if(!(corner>0)) corner=0;
      /* a fired ceramic rectangle has a soft corner, never a stadium end */
      if(corner>Math.min(bw,bh)*0.15) corner=Math.min(bw,bh)*0.15;
      exact='rrect';
    }

    return {
      W:W, H:H, pts:pts, exact:exact,
      cx:((best.mnX+best.mxX)/2)/W, cy:((best.mnY+best.mxY)/2)/H,
      rx:(bw/2)/W, ry:(bh/2)/H,
      corner:corner/W,
      fill:fill
    };
  }

  function getShot(){
    var sel=shotKey(); if(!sel) return null;
    var k=sel.k, cacheKey=k+(sel.rot?'|rot':'');
    var rec=shotCache[cacheKey];
    if(rec) return rec.ok ? rec : null;
    rec={ok:false}; shotCache[cacheKey]=rec;
    var img=new Image();
    /* Shopify's CDN does send CORS headers, and without asking for them the
       canvas taints — which would not show on screen at all, it would kill the
       proof PNG export silently at the moment somebody tries to buy. */
    img.crossOrigin='anonymous';
    img.onload=function(){
      var src=img;
      if(sel.rot){
        /* Rotate once, here, and everything downstream — tracing, placement,
           the clip path — stays orientation-agnostic. */
        var rc=document.createElement('canvas');
        rc.width=img.naturalHeight; rc.height=img.naturalWidth;
        var rx=rc.getContext('2d');
        rx.translate(rc.width/2, rc.height/2);
        rx.rotate(-Math.PI/2);
        rx.drawImage(img, -img.naturalWidth/2, -img.naturalHeight/2);
        rc.naturalWidth=rc.width; rc.naturalHeight=rc.height;
        src=rc;
      }
      var geo=null, shape=k.split('|')[0], ov=SHOTS[k].g;
      if(ov){
        var iw=src.naturalWidth||src.width, ih=src.naturalHeight||src.height;
        /* Turning the image a quarter turn maps (fx,fy) -> (fy, 1-fx) and
           swaps the radii; the corner is stored against the width, so it is
           rescaled to the new one. */
        geo = sel.rot
          ? {W:iw,H:ih, cx:ov.cy, cy:1-ov.cx, rx:ov.ry, ry:ov.rx,
             corner:(ov.corner||0)*ih/iw, exact:ov.exact||null, pts:[], fill:1}
          : {W:iw,H:ih, cx:ov.cx, cy:ov.cy, rx:ov.rx, ry:ov.ry,
             corner:ov.corner||0, exact:ov.exact||null, pts:[], fill:1};
      } else {
        try{ geo=traceOpening(src, SHOTS[k].m, SHOTS[k].t, shape); }
        catch(e){ DBG.trace=String(e); }
      }
      if(!geo){ rec.failed=true; DBG.traced=DBG.traced||{}; DBG.traced[cacheKey]='no geo'; return; }
      DBG.traced=DBG.traced||{}; DBG.traced[cacheKey]={w:geo.W,h:geo.H,rx:geo.rx,ry:geo.ry,fill:+geo.fill.toFixed(3),exact:geo.exact||'traced',corner:+(geo.corner||0).toFixed(4)};
      rec.img=src; rec.geo=geo; rec.mode=SHOTS[k].m; rec.kind=k.split('|')[1];
      rec.key=!!SHOTS[k].key; rec.ok=true;
      rebuild(true);
    };
    img.onerror=function(){ rec.failed=true; DBG.imgError=(DBG.imgError||'')+cacheKey+' '; };
    img.src=SHOT_BASE+SHOTS[k].f;
    return null;
  }

  /* Stage placement of a shot: contain-fit so none of the piece is ever
     cropped, over a blurred cover-fit of the same image so the stage is filled
     edge to edge. A flat fill seams badly against speckled granite and a
     mirrored strip repeats visibly; an out-of-focus enlargement of the shot
     itself works for the granite shots and the white-background ones alike. */
  function shotPlacement(rec){
    var iw=rec.geo.W, ih=rec.geo.H;
    var fit=Math.min(CW/iw, CH/ih)*0.995;
    var dw=iw*fit, dh=ih*fit;
    return {dx:(CW-dw)/2, dy:(CH-dh)/2, dw:dw, dh:dh};
  }

  function shotLayers(rec){
    var img=rec.img, geo=rec.geo, pl=shotPlacement(rec);
    var below=document.createElement('canvas'); below.width=CW; below.height=CH;
    var b=below.getContext('2d');

    if(rec.key){
      /* Shot against a saturated ground purely so it can be cut out — the
         colour is a key, never a backdrop. The piece goes onto the same
         granite the framed oval and the bronze cover sit on, so every variant
         shares one ground and the buyer sees the piece on a marker, which is
         what the page promises. Clipped a whisker inside the outline (0.996)
         because the outermost pixels are part piece and part ground; keep them
         and a coloured fringe rings the whole piece. */
      if(!graniteCache) graniteCache=granite(CW,CH);
      b.drawImage(graniteCache,0,0);
      var S2=Math.min(2*geo.rx*pl.dw, 2*geo.ry*pl.dh);
      b.save();
      b.shadowColor='rgba(0,0,0,.55)';
      b.shadowBlur=Math.max(14,S2*0.08);
      b.shadowOffsetY=Math.max(6,S2*0.05);
      b.shadowOffsetX=Math.max(2,S2*0.015);
      shotClipCtx(b,pl,geo,0.996);
      b.fillStyle='#e9e7e2'; b.fill();
      b.restore();
      b.save();
      shotClipCtx(b,pl,geo,0.996); b.clip();
      /* The glaze reflects the ground it was shot on, so a blue key leaves a
         blue sheen along the top-left highlight — measured 167,196,220 where
         the real porcelain is 226,227,222. Pulling the saturation out puts it
         back to neutral. Safe to apply to the whole layer: this is the bare
         piece, the buyer's picture is drawn separately on top of it. */
      try{ b.filter='saturate(0.18)'; }catch(e){}
      b.drawImage(img,pl.dx,pl.dy,pl.dw,pl.dh);
      b.restore();
    } else {
      var cov=Math.max(CW/geo.W, CH/geo.H)*1.08;
      b.save();
      try{ b.filter='blur(26px) brightness(0.90)'; }catch(e){}
      b.drawImage(img,(CW-geo.W*cov)/2,(CH-geo.H*cov)/2,geo.W*cov,geo.H*cov);
      b.restore();
      b.drawImage(img,pl.dx,pl.dy,pl.dw,pl.dh);
    }

    var ocx=pl.dx+geo.cx*pl.dw, ocy=pl.dy+geo.cy*pl.dh;
    var ow=2*geo.rx*pl.dw, oh=2*geo.ry*pl.dh;
    shapeBox={x:ocx-ow/2,y:ocy-oh/2,w:ow,h:oh,cx:ocx,cy:ocy,kind:spec.s,frame:0,shot:rec};
    DBG.path='shot'; DBG.place={dx:Math.round(pl.dx),dy:Math.round(pl.dy),dw:Math.round(pl.dw),dh:Math.round(pl.dh),ow:Math.round(ow),oh:Math.round(oh)};

    /* The photograph already carries the frame, the rim and the porcelain, so
       the only thing left to add over the buyer's picture is the glaze. */
    var above=document.createElement('canvas'); above.width=CW; above.height=CH;
    var a=above.getContext('2d');
    var R=Math.max(ow,oh);
    a.save();
    shotClipCtx(a,pl,geo,1); a.clip();
    a.save();
    a.translate(ocx-ow*0.23, ocy-oh*0.25); a.rotate(-0.60); a.scale(1,0.26);
    var g2=a.createRadialGradient(0,0,0,0,0,R*0.17);
    g2.addColorStop(0,'rgba(255,255,255,.34)');
    g2.addColorStop(.42,'rgba(255,255,255,.11)');
    g2.addColorStop(1,'rgba(255,255,255,0)');
    a.fillStyle=g2; a.beginPath(); a.arc(0,0,R*0.17,0,6.2832); a.fill();
    a.restore();
    a.save();
    a.translate(ocx+ow*0.25, ocy+oh*0.22); a.rotate(-0.60); a.scale(1,0.22);
    var g3=a.createRadialGradient(0,0,0,0,0,R*0.10);
    g3.addColorStop(0,'rgba(255,255,255,.17)');
    g3.addColorStop(1,'rgba(255,255,255,0)');
    a.fillStyle=g3; a.beginPath(); a.arc(0,0,R*0.10,0,6.2832); a.fill();
    a.restore();
    a.restore();

    return {below:below, above:above, w:ow, h:oh};
  }

  /* How much of the opening the buyer's picture fills.

     On a bare piece the fired image stops short of the edge and leaves a
     porcelain rim — that is what the real thing looks like. Inside a bronze
     frame or cover there is no rim: the metal covers that band already, and
     the picture runs right up to it. A white ring inside the bronze is simply
     wrong, so framed and covered shots fill the opening. 0.995 rather than a
     flat 1 keeps the picture off the bronze itself where the two meet. */
  /* Keyed off the piece KIND, not the detection mode. Those were the same
     thing until the bare shapes were reshot on coloured grounds and started
     using `inner` detection too — at which point keying off the mode quietly
     stripped the porcelain rim from every bare shape. What matters is whether
     the piece sits in metal, which is what `frame` and `cover` mean. */
  function shotInset(rec){
    return (rec && (rec.kind==='frame'||rec.kind==='cover')) ? 0.995 : INSET;
  }

  function shotPathPoints(pl,geo,inset,ccx,ccy){
    var p=geo.pts, i, out=[];
    for(i=0;i<p.length;i++){
      var X=pl.dx+p[i][0]*pl.dw, Y=pl.dy+p[i][1]*pl.dh;
      out.push([ccx+(X-ccx)*inset, ccy+(Y-ccy)*inset]);
    }
    return out;
  }

  function shotClipCtx(x,pl,geo,inset){
    var ccx=pl.dx+geo.cx*pl.dw, ccy=pl.dy+geo.cy*pl.dh;
    var rx=geo.rx*pl.dw*inset, ry=geo.ry*pl.dh*inset;
    x.beginPath();
    if(geo.exact==='ellipse'){ x.ellipse(ccx,ccy,rx,ry,0,0,6.2832); x.closePath(); return; }
    if(geo.exact==='rrect'){
      var rr=Math.min(geo.corner*pl.dw*inset, rx, ry);
      roundRect(x, ccx-rx, ccy-ry, rx*2, ry*2, rr); x.closePath(); return;
    }
    var pts=shotPathPoints(pl,geo,inset,ccx,ccy), i;
    for(i=0;i<pts.length;i++){ if(i===0) x.moveTo(pts[i][0],pts[i][1]); else x.lineTo(pts[i][0],pts[i][1]); }
    x.closePath();
  }

  /* ---------- shape path ---------- */
  function tracePath(x,cx,cy,w,h,kind){
    var l=cx-w/2, t=cy-h/2;
    x.beginPath();
    if(kind==='oval'){ x.ellipse(cx,cy,w/2,h/2,0,0,6.2832); }
    else if(kind==='round'){ var r=Math.min(w,h)/2; x.arc(cx,cy,r,0,6.2832); }
    else if(kind==='rect'||kind==='square'){ var rr=Math.min(w,h)*0.045; roundRect(x,l,t,w,h,rr); }
    else if(kind==='heart'){
      var s=Math.min(w,h);
      x.moveTo(cx, t+h*0.94);
      x.bezierCurveTo(cx-s*0.78, t+h*0.56, cx-s*0.46, t+h*0.02, cx, t+h*0.26);
      x.bezierCurveTo(cx+s*0.46, t+h*0.02, cx+s*0.78, t+h*0.56, cx, t+h*0.94);
    }
    x.closePath();
  }
  function roundRect(x,l,t,w,h,r){
    x.moveTo(l+r,t); x.lineTo(l+w-r,t); x.quadraticCurveTo(l+w,t,l+w,t+r);
    x.lineTo(l+w,t+h-r); x.quadraticCurveTo(l+w,t+h,l+w-r,t+h);
    x.lineTo(l+r,t+h); x.quadraticCurveTo(l,t+h,l,t+h-r);
    x.lineTo(l,t+r); x.quadraticCurveTo(l,t,l+r,t);
  }

  /* ---------- the piece: porcelain + optional bronze frame ---------- */
  function pieceLayers(){
    var rec=null;
    /* A shot that fails must never take the piece down with it — the drawn
       version is a complete fallback, so anything unexpected here falls back
       to it rather than leaving the buyer looking at bare granite. */
    try{ rec=getShot(); }catch(e){ DBG.getShot=String(e); rec=null; }
    if(rec){
      try{ return shotLayers(rec); }
      catch(e2){ DBG.shotLayers=String(e2); rec.ok=false; rec.failed=true; }
    }
    DBG.path='drawn';
    var kind=spec.s;
    var aw=horizontal?spec.h:spec.w, ah=horizontal?spec.w:spec.h;
    var maxW=CW-PAD*2, maxH=CH-PAD*2;
    var sc=Math.min(maxW/aw, maxH/ah);
    var w=aw*sc, h=ah*sc;
    var cx=CW/2, cy=CH/2;
    var frameT = spec.f ? Math.max(16, Math.min(w,h)*0.085) : 0;

    shapeBox={x:cx-w/2,y:cy-h/2,w:w,h:h,cx:cx,cy:cy,kind:kind,frame:frameT};

    /* --- under-layer: porcelain body (drawn beneath the photo) ---

       A fired porcelain blank is not a flat shape. It is slightly domed, it is
       glazed, and it is bright neutral white rather than ivory. Three things
       sell that, in this order: a dome (radial falloff from an upper-left key
       light), light bouncing back into the lower edge, and a soft dark ring
       just inside the outline that gives the piece thickness. A single
       corner-to-corner linear gradient — which is what this used to be — reads
       as a sticker. Everything is parametric on w/h so it holds for every
       shape and both orientations. */
    var S=Math.min(w,h), R=Math.max(w,h);
    var below=document.createElement('canvas'); below.width=CW; below.height=CH;
    var b=below.getContext('2d');

    /* the piece sits ON the granite, so it casts */
    b.save();
    b.shadowColor='rgba(0,0,0,.55)';
    b.shadowBlur=Math.max(14,S*0.08);
    b.shadowOffsetY=Math.max(6,S*0.05);
    b.shadowOffsetX=Math.max(2,S*0.015);
    tracePath(b,cx,cy,w,h,kind);
    b.fillStyle='#eeebe4';
    b.fill();
    b.restore();

    b.save();
    tracePath(b,cx,cy,w,h,kind); b.clip();

    /* The dome. Neutral greys, not cream — sampled off a real proof, the
       porcelain is dead neutral (223,223,223 at the rim, no warm cast at all).
       And the outer stop deliberately lands near the rim colour below, so the
       band and the body meet without a visible seam. */
    var dg=b.createRadialGradient(cx-w*0.22, cy-h*0.28, R*0.03,
                                  cx-w*0.05, cy-h*0.02, R*0.86);
    dg.addColorStop(0,'#fdfdfd');
    dg.addColorStop(.38,'#f6f6f5');
    dg.addColorStop(.70,'#ececea');
    dg.addColorStop(1,'#dcdcd9');
    b.fillStyle=dg; b.fillRect(cx-w,cy-h,w*2,h*2);

    /* light bouncing up into the underside */
    var bg=b.createLinearGradient(0,cy+h*0.12,0,cy+h*0.50);
    bg.addColorStop(0,'rgba(255,255,255,0)');
    bg.addColorStop(1,'rgba(255,255,255,.22)');
    b.fillStyle=bg; b.fillRect(cx-w,cy-h,w*2,h*2);

    /* The rim, and the thing that was actually wrong.

       Ours was a bright white band (measured 252) where a real fired piece
       reads as mid grey — I sampled one all the way round: 226 at the top,
       220 left, 218 right, 193 at the lower corners, 174 at the bottom. Never
       white anywhere. Bright white is what made ours look like a photo sitting
       in a paper mount instead of an image fired into the glaze.

       So the band is painted with OPAQUE greys rather than white-with-alpha —
       alpha over a bright dome is how it got blown out in the first place.
       Stroking the outline at twice the rim width puts exactly half inside the
       clip, so the band lands on the rim and the rest falls away. */
    b.save();
    b.lineWidth=(1-INSET)*(w+h)/2*1.15;
    var eg=b.createLinearGradient(cx-w*0.45,cy-h*0.45,cx+w*0.45,cy+h*0.45);
    eg.addColorStop(0,'#e8e8e6');
    eg.addColorStop(.35,'#dedede');
    eg.addColorStop(.65,'#c6c6c3');
    eg.addColorStop(1,'#aeacaa');
    b.strokeStyle=eg;
    tracePath(b,cx,cy,w,h,kind);
    b.stroke();
    b.restore();

    /* The full-strength glint lives HERE, under the photo, not over it. On a
       bare blank it is what makes the surface read as glazed; the moment a
       portrait is placed it is covered, and the restrained version in the
       layer above takes over. One highlight cannot serve both — strong enough
       to sell gloss on white porcelain is strong enough to streak a face. */
    b.save();
    b.translate(cx-w*0.23, cy-h*0.25);
    b.rotate(-0.60);
    b.scale(1,0.26);
    var bs=b.createRadialGradient(0,0,0,0,0,R*0.17);
    bs.addColorStop(0,'rgba(255,255,255,.85)');
    bs.addColorStop(.42,'rgba(255,255,255,.26)');
    bs.addColorStop(1,'rgba(255,255,255,0)');
    b.fillStyle=bs;
    b.beginPath(); b.arc(0,0,R*0.17,0,6.2832); b.fill();
    b.restore();

    b.restore();

    /* --- over-layer: bronze frame + rim + sheen --- */
    var above=document.createElement('canvas'); above.width=CW; above.height=CH;
    var a=above.getContext('2d');

    if(spec.f){
      a.save();
      a.lineWidth=frameT;
      tracePath(a,cx,cy,w+frameT,h+frameT,kind);
      var fg=a.createLinearGradient(cx-w/2,cy-h/2,cx+w/2,cy+h/2);
      fg.addColorStop(0,'#7d5f22'); fg.addColorStop(.18,'#e2c67e'); fg.addColorStop(.36,'#a8823a');
      fg.addColorStop(.54,'#f0dca4'); fg.addColorStop(.72,'#8f6c28'); fg.addColorStop(1,'#d9b769');
      a.strokeStyle=fg;
      a.shadowColor='rgba(0,0,0,.45)'; a.shadowBlur=16; a.shadowOffsetY=7;
      a.stroke();
      a.restore();
      /* inner dark seat */
      a.save(); a.lineWidth=2.5; tracePath(a,cx,cy,w+2,h+2,kind);
      a.strokeStyle='rgba(60,44,14,.55)'; a.stroke(); a.restore();
    } else {
      a.save(); a.lineWidth=1.5; tracePath(a,cx,cy,w,h,kind);
      a.strokeStyle='rgba(96,90,78,.45)'; a.stroke(); a.restore();
    }

    if(spec.cover){
      a.save();
      a.lineWidth=Math.max(10,frameT*0.6);
      tracePath(a,cx,cy-h*0.02,w+frameT*2.1,h+frameT*2.1,kind);
      a.strokeStyle='rgba(146,112,44,.75)'; a.stroke();
      a.restore();
    }

    /* Where the image meets the rim. On the real thing this edge is crisp —
       the image is fired into the glaze, it does not fade out — and with the
       rim now only ~2% of the width, the old white glow was wide enough to
       swallow most of it. Just enough to kill the aliased step. */
    a.save();
    tracePath(a,cx,cy,w*INSET,h*INSET,kind);
    a.lineWidth=Math.max(1,Math.min(w,h)*0.004);
    a.strokeStyle='rgba(255,255,255,.34)';
    a.shadowColor='rgba(255,255,255,.42)';
    a.shadowBlur=Math.max(1.5,Math.min(w,h)*0.007);
    a.stroke();
    a.restore();

    /* --- glaze, over the photo ---

       Kept deliberately restrained: this sits on top of somebody's portrait,
       and gloss that washes out a face is worse than no gloss. A broad soft
       glow places the light source, and one crisp squashed streak does the
       actual work of saying "glazed" rather than "printed". */
    a.save();
    tracePath(a,cx,cy,w,h,kind); a.clip();

    var g1=a.createRadialGradient(cx-w*0.24, cy-h*0.28, 0,
                                  cx-w*0.24, cy-h*0.28, R*0.55);
    g1.addColorStop(0,'rgba(255,255,255,.26)');
    g1.addColorStop(.45,'rgba(255,255,255,.08)');
    g1.addColorStop(1,'rgba(255,255,255,0)');
    a.fillStyle=g1; a.fillRect(cx-w,cy-h,w*2,h*2);

    /* the specular streak */
    a.save();
    a.translate(cx-w*0.23, cy-h*0.25);
    a.rotate(-0.60);
    a.scale(1,0.26);
    var g2=a.createRadialGradient(0,0,0,0,0,R*0.17);
    g2.addColorStop(0,'rgba(255,255,255,.40)');
    g2.addColorStop(.42,'rgba(255,255,255,.13)');
    g2.addColorStop(1,'rgba(255,255,255,0)');
    a.fillStyle=g2;
    a.beginPath(); a.arc(0,0,R*0.17,0,6.2832); a.fill();
    a.restore();

    /* a much smaller second catch-light, low and to the right — a single
       highlight on its own reads as a gradient, two read as a curved surface */
    a.save();
    a.translate(cx+w*0.25, cy+h*0.22);
    a.rotate(-0.60);
    a.scale(1,0.22);
    var g3=a.createRadialGradient(0,0,0,0,0,R*0.10);
    g3.addColorStop(0,'rgba(255,255,255,.20)');
    g3.addColorStop(1,'rgba(255,255,255,0)');
    a.fillStyle=g3;
    a.beginPath(); a.arc(0,0,R*0.10,0,6.2832); a.fill();
    a.restore();

    a.restore();

    return {below:below, above:above, w:w, h:h};
  }

  function clipShape(){
    var s0=shapeBox;

    /* When the piece is a photograph, clip to the outline traced from that
       photograph rather than to our idea of the shape. A drawn heart and a
       photographed heart are not the same curve, and the buyer would see the
       difference as a sliver of their picture lying over the bronze. */
    if(s0.shot && s0.shot.geo){
      var geo=s0.shot.geo, pl=shotPlacement(s0.shot), ins=shotInset(s0.shot);
      var ccx=pl.dx+geo.cx*pl.dw, ccy=pl.dy+geo.cy*pl.dh;
      var rx=geo.rx*pl.dw*ins, ry=geo.ry*pl.dh*ins;

      /* An ellipse traced as 360 line segments still shows every pixel of
         noise in the trace. Where the opening IS an ellipse, use one. */
      if(geo.exact==='ellipse'){
        return new fabric.Ellipse({rx:rx, ry:ry, left:ccx, top:ccy,
          originX:'center', originY:'center', absolutePositioned:true});
      }
      if(geo.exact==='rrect'){
        var rr=Math.min(geo.corner*pl.dw*ins, rx, ry);
        return new fabric.Rect({width:rx*2, height:ry*2, left:ccx, top:ccy,
          originX:'center', originY:'center', rx:rr, ry:rr, absolutePositioned:true});
      }
      var pts=shotPathPoints(pl,geo,ins,ccx,ccy), dd='', j;
      for(j=0;j<pts.length;j++) dd+=(j===0?'M ':' L ')+pts[j][0].toFixed(2)+' '+pts[j][1].toFixed(2);
      return new fabric.Path(dd+' z',{absolutePositioned:true});
    }

    var s={kind:s0.kind, cx:s0.cx, cy:s0.cy, w:s0.w*INSET, h:s0.h*INSET};
    if(s.kind==='oval'||s.kind==='round'){
      var r = s.kind==='round' ? Math.min(s.w,s.h)/2 : 0;
      return new fabric.Ellipse({rx:(s.kind==='round'?r:s.w/2), ry:(s.kind==='round'?r:s.h/2),
        left:s.cx, top:s.cy, originX:'center', originY:'center', absolutePositioned:true});
    }
    if(s.kind==='heart'){
      /* built from the SAME maths as tracePath, in absolute canvas units.
         Do not scaleToWidth/scaleToHeight here — the control points make the
         path's bounding box wider than the drawn heart, and scaling to fit it
         produced a clip far larger than the piece. */
      var hs=Math.min(s.w,s.h), ht=s.cy-s.h/2;
      var d='M '+s.cx+' '+(ht+s.h*0.94)+
            ' C '+(s.cx-hs*0.78)+' '+(ht+s.h*0.56)+' '+(s.cx-hs*0.46)+' '+(ht+s.h*0.02)+' '+s.cx+' '+(ht+s.h*0.26)+
            ' C '+(s.cx+hs*0.46)+' '+(ht+s.h*0.02)+' '+(s.cx+hs*0.78)+' '+(ht+s.h*0.56)+' '+s.cx+' '+(ht+s.h*0.94)+' z';
      return new fabric.Path(d,{absolutePositioned:true});
    }
    return new fabric.Rect({width:s.w, height:s.h, left:s.cx, top:s.cy,
      originX:'center', originY:'center', rx:Math.min(s.w,s.h)*0.045, ry:Math.min(s.w,s.h)*0.045,
      absolutePositioned:true});
  }

  function rebuild(keepArt){
    var L=pieceLayers();

    /* Tracked separately from graniteCache. A keyed shot builds the granite
       itself, so testing the cache alone would skip setting the background —
       invisible while a shot covers the stage, and a bare stage the moment
       anything falls back to the drawn piece. */
    if(!graniteCache) graniteCache=granite(CW,CH);
    if(!graniteBgSet){
      graniteBgSet=true;
      canvas.setBackgroundImage(
        new fabric.Image(graniteCache,{selectable:false,evented:false,left:0,top:0}),
        canvas.renderAll.bind(canvas));
    }

    /* remove old furniture */
    canvas.getObjects().slice().forEach(function(o){
      if(o.gczRole==='below'||o.gczRole==='above'||o.gczRole==='ph') canvas.remove(o);
    });

    var below=new fabric.Image(L.below,{selectable:false,evented:false,left:0,top:0,gczRole:'below'});
    var above=new fabric.Image(L.above,{selectable:false,evented:false,left:0,top:0,gczRole:'above'});
    canvas.add(below); canvas.sendToBack(below);
    canvas.add(above); canvas.bringToFront(above);

    if(photo){
      photo.clipPath=clipShape();
      if(!keepArt) fitPhoto(); else ensureCover();
      canvas.bringToFront(photo);
    } else {
      placeholder=new fabric.Text('Upload a photograph\nto begin',{
        left:shapeBox.cx, top:shapeBox.cy, originX:'center', originY:'center',
        fontFamily:'Georgia, "Times New Roman", serif',
        fontSize:Math.max(13,Math.min(shapeBox.w,shapeBox.h)*0.085),
        fill:'rgba(90,84,70,.62)', textAlign:'center', lineHeight:1.35,
        selectable:false, evented:false, gczRole:'ph'
      });
      canvas.add(placeholder); canvas.bringToFront(placeholder);
    }
    texts.forEach(function(t){ t.clipPath=clipShape(); canvas.bringToFront(t); });
    canvas.bringToFront(above);
    canvas.requestRenderAll();
  }

  /* keep the fixed 760x620 art board, scale it down with CSS on small screens */
  function fitStage(){
    if(!canvas) return;
    var stage=$('gcz-stage');
    var avail=stage.clientWidth;
    if(!avail) return;
    var s=Math.min(1, avail/CW);
    /* no-op when nothing actually changed — fitStage alters the stage's own
       height, so an unguarded ResizeObserver would feed back into itself */
    if(Math.abs(s-stageScale) < 0.001 && fitStage._done) { placeTTB(); return; }
    stageScale=s; fitStage._done=true;
    canvas.setDimensions({width:Math.round(CW*s)+'px', height:Math.round(CH*s)+'px'},{cssOnly:true});
    placeTTB();
  }

  /* ---------- floating text toolbar ---------- */
  function activeText(){
    var o=canvas && canvas.getActiveObject();
    if(o && (o.type==='i-text'||o.type==='text') && o.gczRole!=='ph'){ lastText=o; return o; }
    return null;
  }
  /* Using the font dropdown moves focus off the canvas. Fall back to the last
     text that was selected so the toolbar still acts on the right object. */
  function targetText(){
    var o=activeText();
    if(o) return o;
    return (lastText && texts.indexOf(lastText)!==-1) ? lastText : null;
  }
  /* Same breakpoint as the layout: below 980px the panel stacks under the
     canvas, and anything that floats over the picture is in the way. */
  function docked(){ return window.matchMedia('(max-width:980px)').matches; }

  /* On a stacked layout the buttons are below the picture, so acting on one
     (uploading, adding text) changes something the buyer cannot currently see.
     Bring the piece back into view first. */
  /* Height of anything pinned to the top of the screen, so the scroll below
     does not park the picture underneath the header. Ella's mobile header is
     `position:sticky` and about 70px; measured rather than hard-coded so a
     theme change cannot silently break it. */
  function stickyTop(){
    var h=0, els=document.querySelectorAll('header, .shopify-section-header, [class*="header-mobile"], [class*="header-sticky"]');
    for(var i=0;i<els.length;i++){
      var el=els[i], cs;
      try{ cs=getComputedStyle(el); }catch(e){ continue; }
      if(cs.position!=='sticky' && cs.position!=='fixed') continue;
      if(cs.visibility==='hidden' || cs.display==='none') continue;
      var r=el.getBoundingClientRect();
      if(r.height>0 && r.height<200 && r.top<=1 && r.width>window.innerWidth*0.6) h=Math.max(h,r.height);
    }
    return h;
  }

  /* `block:'center'` looked right but was wrong here: centring the picture
     leaves only half a screen underneath, and the text toolbar that appears
     directly below it falls off the bottom. Put the picture just under the
     header instead, so the picture and its controls share the screen. */
  function stageScrollTarget(stage){
    var y = stage.getBoundingClientRect().top + (window.pageYOffset||document.documentElement.scrollTop||0)
            - stickyTop() - 8;
    return y<0 ? 0 : y;
  }
  function scrollWin(y){
    try{ window.scrollTo({top:y, behavior:'smooth'}); }
    catch(e){ window.scrollTo(0,y); }
  }
  function revealStage(){
    if(!docked()) return;
    var stage=$('gcz-stage'); if(!stage) return;
    scrollWin(stageScrollTarget(stage));
    /* Images further up the page finish loading while this scroll is running
       and shove the picture down behind the header. Measured it landing 200px
       off for exactly that reason. Two cheap corrections, and only while the
       picture is still out of place — never fighting a scroll the buyer made. */
    var fix=function(){
      var st=$('gcz-stage'); if(!st) return;
      var top=st.getBoundingClientRect().top, head=stickyTop();
      /* Deliberately a loose band. A late pass can land while someone is
         already typing, and yanking the page then is worse than a picture
         sitting a little lower than ideal — so correct only when it is
         genuinely hidden: tucked under the header, or below halfway down. */
      if(top < head-2 || top > window.innerHeight*0.5) scrollWin(stageScrollTarget(st));
    };
    setTimeout(fix, 550); setTimeout(fix, 1200); setTimeout(fix, 2400);
  }

  /* Below 980px the panel stacks under the canvas, which puts the nudge/resize
     controls a long scroll away from the picture they move — you tap an arrow
     and cannot see what happened. Dock the pad directly under the stage there,
     and put it back in the panel on wide screens. */
  var padHome=null, padAnchor=null;
  function padDocked(){ return window.matchMedia('(max-width:980px)').matches; }
  function placePad(){
    var grp=$('gcz-move-grp'), dock=$('gcz-movedock');
    if(!grp || !dock) return;
    /* remember where it lived, and what followed it, so putting it back on a
       wide screen restores its position rather than dumping it at the end */
    if(!padHome){ padHome=grp.parentNode; padAnchor=grp.nextElementSibling; }
    if(padDocked()){
      if(grp.parentNode!==dock) dock.appendChild(grp);
    } else if(grp.parentNode===dock && padHome){
      padHome.insertBefore(grp, padAnchor);
    }
  }

  function placeTTB(){
    var ttb=$('gcz-ttb'); if(!ttb) return;
    var o=activeText();
    if(!o){ ttb.hidden=true; return; }
    ttb.hidden=false;
    syncTTB(o);

    /* phone: sit under the picture rather than on top of it */
    var dock=$('gcz-ttbdock');
    if(docked()){
      if(dock && ttb.parentNode!==dock){ dock.appendChild(ttb); }
      ttb.style.left=''; ttb.style.top='';
      return;
    }
    if(dock && ttb.parentNode===dock){ $('gcz-stage').appendChild(ttb); }

    var br=o.getBoundingRect(true,true);
    var stage=$('gcz-stage');
    var cw=stage.clientWidth, ch=stage.clientHeight;
    var tw=ttb.offsetWidth, th=ttb.offsetHeight;
    var left=(br.left+br.width/2)*stageScale - tw/2;
    var top =(br.top)*stageScale - th - 10;
    if(top<4) top=(br.top+br.height)*stageScale + 10;
    top=Math.max(4, Math.min(top, ch-th-4));
    left=Math.max(4, Math.min(left, cw-tw-4));
    ttb.style.left=Math.round(left)+'px';
    ttb.style.top =Math.round(top)+'px';
  }
  function syncTTB(o){
    var f=$('gcz-tt-font');
    if(f){ for(var i=0;i<f.options.length;i++){ if(f.options[i].value===o.fontFamily){ f.selectedIndex=i; break; } } }
    document.querySelectorAll('.gcz__ttb .gcz__col').forEach(function(sw){
      sw.setAttribute('aria-pressed', String(sw.getAttribute('data-color').toLowerCase()===String(o.fill).toLowerCase()));
    });
    var set=function(k,v){ var b=document.querySelector('.gcz__ttb [data-tt='+k+']'); if(b) b.setAttribute('aria-pressed',String(!!v)); };
    set('bold', o.fontWeight==='bold');
    set('italic', o.fontStyle==='italic');
    set('underline', !!o.underline);
  }
  function restack(){
    canvas.getObjects().forEach(function(o){ if(o.gczRole==='above') canvas.bringToFront(o); });
    canvas.requestRenderAll();
  }
  function newText(str,opts){
    var t=new fabric.IText(str, Object.assign({
      left:shapeBox.cx, top:shapeBox.cy+shapeBox.h*0.28, originX:'center', originY:'center',
      fontFamily:'Georgia, serif', fontSize:Math.max(14,shapeBox.h*0.062),
      fill:'#ffffff', stroke:'rgba(0,0,0,.55)', strokeWidth:0.6, paintFirst:'stroke',
      textAlign:'center', editingBorderColor:'#c8973a'
    }, opts||{}));
    t.clipPath=clipShape();
    texts.push(t); canvas.add(t); restack(); canvas.setActiveObject(t);
    return t;
  }

  /* A heart tapers to a point, so a photo centred in its bounding box puts the
     chin exactly where the shape pinches. Sitting the picture a little higher
     lands the face in the wide part. Buyers can still drag it wherever they
     like; this only changes where it starts. */
  function frameOffsetY(){
    return (spec && spec.s==='heart') ? -shapeBox.h*0.06 : 0;
  }
  /* Shifting up by that much uncovers the point unless the photo also grows by
     the same amount: half-height is ~0.51h, so 0.06h needs ~1.12x. 1.14 leaves
     a margin. */
  function frameZoom(){
    return (spec && spec.s==='heart') ? 1.14 : 1;
  }

  function fitPhoto(){
    if(!photo) return;
    var s=shapeBox;
    var sc=Math.max((s.w*INSET)/photo.width, (s.h*INSET)/photo.height)*1.02*frameZoom();
    photo.set({scaleX:sc,scaleY:sc,left:s.cx,top:s.cy+frameOffsetY(),angle:0,originX:'center',originY:'center'});
    photo.setCoords();
  }

  /* When the shape or size changes we keep the crop the buyer set, but a bigger
     piece must never end up with bare porcelain showing round the photo. */
  function ensureCover(){
    if(!photo) return;
    var s=shapeBox;
    var need=Math.max((s.w*INSET)/photo.width, (s.h*INSET)/photo.height)*1.02*frameZoom();
    if((photo.scaleX||1) < need - 0.0001){
      photo.set({scaleX:need, scaleY:need, left:s.cx, top:s.cy+frameOffsetY()});
      photo.setCoords();
    }
  }

  function setSpec(newSku){
    sku=newSku; spec=SPECS[newSku]||SPECS.V2;
    $('gcz-sku').textContent = newSku + ' · ' + SHAPE_LABEL[spec.s] + ' · ' + spec.w + '" x ' + spec.h + '"' + (spec.f?' · bronze frame':'');
    var square = (spec.s==='round'||spec.s==='square'||spec.s==='heart'||Math.abs(spec.w-spec.h)<0.01);
    $('gcz-orient-grp').style.display = square ? 'none' : '';
    var sw=$('gcz-small'); if(sw) sw.hidden = !spec.small;
    if(square) horizontal=false;
    setSeg();
    rebuild(true);
  }
  function setSeg(){
    $('gcz-vert').setAttribute('aria-pressed', String(!horizontal));
    $('gcz-horz').setAttribute('aria-pressed', String(horizontal));
  }

  function selectedOrPhoto(){ return canvas.getActiveObject() || photo; }

  /* Deliberately permissive — this only gates the button. A typo'd domain still
     gets through, which is why the confirmation page repeats the address. */
  function emailOK(v){ return /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(v.trim()); }

  function validate(){
    var ok = !!photo && $('gcz-agree').checked &&
             $('gcz-approver').value.trim().length>1 &&
             $('gcz-initials').value.trim().length>0 &&
             emailOK($('gcz-email').value);
    $('gcz-submit').disabled = !ok;
    return ok;
  }

  function dataURLtoFile(url,name){
    var arr=url.split(','), mime=arr[0].match(/:(.*?);/)[1], bin=atob(arr[1]);
    var n=bin.length, u8=new Uint8Array(n);
    while(n--) u8[n]=bin.charCodeAt(n);
    return new File([u8],name,{type:mime});
  }
  function putFile(input,file){
    var dt=new DataTransfer(); dt.items.add(file); input.files=dt.files;
  }

  function boot(){
    $('gcz-loading').style.display='none';
    canvas=new fabric.Canvas('gcz-canvas',{preserveObjectStacking:true,selection:false,
      allowTouchScrolling:true,backgroundColor:'#e9ece7'});
    fabric.Object.prototype.set({
      transparentCorners:false, cornerColor:'#c8973a', cornerStrokeColor:'#0f2c1b',
      borderColor:'#c8973a', cornerSize:12, cornerStyle:'circle', padding:2
    });

    var sel=$('gcz-variant');
    var q=new URLSearchParams(location.search).get('variant');
    if(q){ for(var i=0;i<sel.options.length;i++){ if(sel.options[i].value===q){ sel.selectedIndex=i; break; } } }
    syncVariant();

    sel.addEventListener('change', syncVariant);
    function syncVariant(){
      var o=sel.options[sel.selectedIndex];
      $('gcz-variant-id').value=o.value;
      $('gcz-price').textContent=o.getAttribute('data-price');
      setSpec((o.getAttribute('data-sku')||'V2').toUpperCase());
      try{ history.replaceState({},'',location.pathname+'?variant='+o.value); }catch(e){}
    }

    $('gcz-vert').addEventListener('click',function(){ horizontal=false; setSeg(); rebuild(false); });
    $('gcz-horz').addEventListener('click',function(){ horizontal=true;  setSeg(); rebuild(false); });

    $('gcz-upload').addEventListener('click',function(){ $('gcz-f-original').click(); });
    $('gcz-f-original').addEventListener('change',function(e){
      var f=e.target.files && e.target.files[0]; if(!f) return;
      originalFile=f;
      $('gcz-filename').textContent='Photo: '+f.name;
      var rd=new FileReader();
      rd.onload=function(ev){
        fabric.Image.fromURL(ev.target.result,function(img){
          if(photo) canvas.remove(photo);
          photo=img;
          photo.set({originX:'center',originY:'center'});
          photo.clipPath=clipShape();
          canvas.add(photo); fitPhoto();
          canvas.setActiveObject(photo);
          rebuild(true); validate();
          revealStage();
        });
      };
      rd.readAsDataURL(f);
    });

    $('gcz-addtext').addEventListener('click',function(){
      var t=newText('Your text');
      canvas.requestRenderAll(); placeTTB();
      revealStage();
      /* let the scroll settle before focusing, or the on-screen keyboard and the
         smooth scroll fight each other and you land somewhere in between */
      setTimeout(function(){
        t.enterEditing(); t.selectAll();
        canvas.requestRenderAll(); placeTTB();
      }, docked() ? 420 : 0);
    });

    /* keep the toolbar glued to the selected text */
    ['selection:created','selection:updated','object:moving','object:scaling','object:rotating',
     'object:modified','text:changed','text:editing:entered','text:editing:exited']
      .forEach(function(ev){ canvas.on(ev, placeTTB); });
    canvas.on('selection:cleared', function(){ $('gcz-ttb').hidden=true; });

    /* Clicking the toolbar must not drop the selection — but never call
       preventDefault on the <select>, or Chrome refuses to open the dropdown. */
    $('gcz-ttb').addEventListener('mousedown', function(e){
      if(e.target && (e.target.tagName==='SELECT' || e.target.closest('select'))) return;
      e.preventDefault();
    });

    $('gcz-tt-font').addEventListener('change', function(){
      var o=targetText(); if(!o) return;
      o.set('fontFamily', this.value);
      canvas.setActiveObject(o); canvas.requestRenderAll(); placeTTB();
    });
    document.querySelectorAll('.gcz__ttb .gcz__col').forEach(function(sw){
      sw.addEventListener('click', function(){
        var o=targetText(); if(!o) return;
        var v=sw.getAttribute('data-color');
        var dark = (v==='#1a1a1a' || v==='#6b6b6b');
        o.set({fill:v, stroke: dark ? 'rgba(255,255,255,.6)' : 'rgba(0,0,0,.55)'});
        canvas.setActiveObject(o); canvas.requestRenderAll(); placeTTB();
      });
    });

    document.querySelectorAll('.gcz__ttb [data-tt]').forEach(function(b){
      b.addEventListener('click', function(){
        var o=targetText(); if(!o) return;
        canvas.setActiveObject(o);
        var k=b.getAttribute('data-tt');
        if(k==='smaller') o.set('fontSize', Math.max(8, o.fontSize-2));
        else if(k==='bigger') o.set('fontSize', o.fontSize+2);
        else if(k==='bold') o.set('fontWeight', o.fontWeight==='bold'?'normal':'bold');
        else if(k==='italic') o.set('fontStyle', o.fontStyle==='italic'?'normal':'italic');
        else if(k==='underline') o.set('underline', !o.underline);
        else if(k==='dup'){
          var c=newText(o.text,{fontFamily:o.fontFamily,fontSize:o.fontSize,fontWeight:o.fontWeight,
            fontStyle:o.fontStyle,underline:o.underline,fill:o.fill,stroke:o.stroke,angle:o.angle,
            left:o.left+18, top:o.top+18});
          canvas.requestRenderAll(); placeTTB(); return;
        }
        else if(k==='forward'){ canvas.bringForward(o); restack(); }
        else if(k==='back'){ canvas.sendBackwards(o); restack(); }
        else if(k==='del'){
          texts=texts.filter(function(t){return t!==o;});
          if(lastText===o) lastText=null;
          canvas.remove(o); canvas.discardActiveObject();
          $('gcz-ttb').hidden=true; canvas.requestRenderAll(); return;
        }
        o.setCoords(); canvas.requestRenderAll(); placeTTB();
      });
    });

    document.querySelectorAll('[data-nudge]').forEach(function(b){
      b.addEventListener('click',function(){
        var o=selectedOrPhoto(); if(!o) return;
        var d=b.getAttribute('data-nudge'), s=6;
        if(d==='up')o.top-=s; if(d==='down')o.top+=s; if(d==='left')o.left-=s; if(d==='right')o.left+=s;
        o.setCoords(); canvas.requestRenderAll(); placeTTB();
      });
    });
    document.querySelectorAll('[data-scale]').forEach(function(b){
      b.addEventListener('click',function(){
        var o=selectedOrPhoto(); if(!o) return;
        var f=b.getAttribute('data-scale')==='1'?1.06:1/1.06;
        o.scaleX*=f; o.scaleY*=f; o.setCoords(); canvas.requestRenderAll(); placeTTB();
      });
    });
    document.querySelectorAll('[data-rotate]').forEach(function(b){
      b.addEventListener('click',function(){
        var o=selectedOrPhoto(); if(!o) return;
        o.angle=(o.angle||0)+parseFloat(b.getAttribute('data-rotate'));
        o.setCoords(); canvas.requestRenderAll(); placeTTB();
      });
    });
    $('gcz-center').addEventListener('click',function(){
      var o=selectedOrPhoto(); if(!o) return;
      o.set({left:shapeBox.cx, top:shapeBox.cy}); o.setCoords(); canvas.requestRenderAll(); placeTTB();
    });
    $('gcz-delete').addEventListener('click',function(){
      var o=canvas.getActiveObject();
      /* nothing picked? fall back to the photo, which is what people mean */
      if(!o) o=photo;
      if(!o) return;
      if(o===photo){
        canvas.remove(photo); photo=null; originalFile=null;
        $('gcz-f-original').value='';
        $('gcz-filename').textContent='';
        canvas.discardActiveObject();
        $('gcz-ttb').hidden=true;
        rebuild(false);          /* brings the "upload a photograph" prompt back */
        validate();              /* and disables Approve until a new one is added */
        return;
      }
      texts=texts.filter(function(t){return t!==o;});
      if(lastText===o) lastText=null;
      canvas.remove(o); canvas.discardActiveObject();
      $('gcz-ttb').hidden=true; canvas.requestRenderAll();
    });

    /* how-to-measure dialog */
    var mod=$('gcz-measure');
    function openMeasure(){ if(mod){ mod.hidden=false; document.body.style.overflow='hidden'; } }
    function closeMeasure(){ if(mod){ mod.hidden=true; document.body.style.overflow=''; } }
    var mo=$('gcz-measure-open'); if(mo) mo.addEventListener('click', openMeasure);
    var mc=$('gcz-measure-close'); if(mc) mc.addEventListener('click', closeMeasure);
    if(mod) mod.addEventListener('click', function(e){ if(e.target===mod) closeMeasure(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeMeasure(); });
    document.querySelectorAll('.gcz__tabs [data-tab]').forEach(function(tb){
      tb.addEventListener('click', function(){
        var want=tb.getAttribute('data-tab');
        document.querySelectorAll('.gcz__tabs [data-tab]').forEach(function(x){
          x.setAttribute('aria-selected', String(x===tb));
        });
        document.querySelectorAll('.gcz__pane').forEach(function(pn){
          pn.hidden = pn.getAttribute('data-pane')!==want;
        });
      });
    });

    $('gcz-download').addEventListener('click',function(){
      canvas.discardActiveObject(); $('gcz-ttb').hidden=true; canvas.requestRenderAll();
      var url=canvas.toDataURL({format:'png',multiplier:1.6});
      var a=document.createElement('a'); a.href=url;
      a.download='glory-roses-proof-'+sku+'.png'; a.click();
    });

    ['gcz-agree','gcz-approver','gcz-initials','gcz-email'].forEach(function(id){
      $(id).addEventListener('input',validate); $(id).addEventListener('change',validate);
    });

    $('gcz-form').addEventListener('submit',function(e){
      if(!validate()){
        e.preventDefault();
        $('gcz-err').textContent = !photo ? 'Please upload a photograph first.'
          : !emailOK($('gcz-email').value) ? 'Please enter the email address we should send your proof to.'
          : 'Please tick the box and type your full name and initials to approve.';
        return;
      }
      canvas.discardActiveObject(); $('gcz-ttb').hidden=true; canvas.requestRenderAll();
      var proofURL=canvas.toDataURL({format:'png',multiplier:1.6});
      putFile($('gcz-f-proof'), dataURLtoFile(proofURL,'proof-'+sku+'.png'));
      if(originalFile) putFile($('gcz-f-original'), originalFile);

      $('gcz-p-item').value=sku;
      $('gcz-p-shape').value=SHAPE_LABEL[spec.s]+(spec.f?' with bronze frame':'')+(spec.cover?' + bronze cover':'');
      $('gcz-p-size').value=(horizontal?spec.h+'" x '+spec.w+'"':spec.w+'" x '+spec.h+'"');
      $('gcz-p-orient').value=horizontal?'Horizontal':'Vertical';
      $('gcz-p-email').value=$('gcz-email').value.trim();
      $('gcz-p-approver').value=$('gcz-approver').value.trim();
      $('gcz-p-initials').value=$('gcz-initials').value.trim().toUpperCase();
      $('gcz-p-approvedon').value=new Date().toString();
      $('gcz-p-lettering').value=texts.map(function(t){return t.text;}).join(' | ') || 'None';
      $('gcz-p-design').value=JSON.stringify({
        sku:sku, shape:spec.s, framed:!!spec.f, orientation:horizontal?'H':'V',
        photo: photo?{left:Math.round(photo.left),top:Math.round(photo.top),
                      scale:+(photo.scaleX||1).toFixed(4),angle:Math.round(photo.angle||0)}:null,
        texts: texts.map(function(t){return {text:t.text,left:Math.round(t.left),top:Math.round(t.top),
                      size:Math.round(t.fontSize),angle:Math.round(t.angle||0),fill:t.fill,
                      font:t.fontFamily,weight:t.fontWeight,style:t.fontStyle,underline:!!t.underline};})
      });
    });

    setSpec(sku||'V2');
    fitStage();
    placePad();
    validate();

    /* widths can still shift as the theme finishes laying out */
    setTimeout(function(){ fitStage(); canvas.calcOffset(); }, 350);
    window.addEventListener('load', function(){ fitStage(); canvas.calcOffset(); });
    if(window.ResizeObserver){
      new ResizeObserver(function(){ fitStage(); canvas.calcOffset(); }).observe($('gcz-stage'));
    }

    var rt;
    window.addEventListener('resize',function(){
      clearTimeout(rt); rt=setTimeout(function(){ fitStage(); canvas.calcOffset(); placePad(); },140);
    });
  }

  function whenReady(){
    if(window.fabric){ boot(); return; }
    var n=0, iv=setInterval(function(){
      if(window.fabric){ clearInterval(iv); boot(); }
      else if(++n>120){ clearInterval(iv); $('gcz-loading').textContent='The customizer could not load. Please call or text 818-639-3993 and we will design it with you.'; }
    },100);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',whenReady); else whenReady();
})();
